<template>
  <!-- 产品详情 -->
  <div class="productDetail">
    <!-- 头部 -->
    <headerNav activeIndex="newsCenter" @setBanner="setBanner"></headerNav>
    <!-- 轮播图 -->
    <bannerNav
      :carousel="info.carousel"
      :Mcarousel="info.Mcarousel"
    ></bannerNav>
    <div class="pc" style="padding: 50px 72px 148px;background:#f8f8f8;" id="mainNav">
      <div class="maxWidth mainNav" style="background:#fff;padding:0 100px;" ref="mainNav">
        <!-- 右侧内容 -->
        <div class="mainContent" style="padding-top:40px;">
          <div
            style="
              border-bottom: 1px solid #719468;
              padding: 14px 0;
              line-height: 23px;
              display: flex;
              margin-bottom:60px;
            "
          >
            <div style="font-size: 18px" class="clickBtn1" @click="goHome">
              <i class="el-icon-location" style="color:#3f6b33;"></i> 首页
            </div>
            <div style="font-size: 18px; margin: 0 5px">- <span @click="goback"  class="clickBtn1">新闻中心</span> </div>
          </div>
          <div
            style="
              text-align: center;
              border-bottom: 1px solid #e5e5e5;
              padding-bottom: 10px;
            "
          >
            <div style="color: #719468; font-size: 36px; ">
              {{ newsDetail.title }}
            </div>
            <div
              style="
                font-size: 14px;
                color: #535353;
                line-height: 23px;
                margin-top: 20px;
              "
            >
              <span style="margin-right: 16px"
                >日期：{{ newsDetail.releaseTime }}</span
              >
              <span style="margin-right: 16px"
                >作者：{{ newsDetail.authorName }}</span
              >
              <i class="el-icon-view" style="margin-right: 4px"></i>
              <span>阅读量：{{ newsDetail.readingOnFictitiou }}</span>
            </div>
          </div>
          <div
            style="margin-top: 50px; line-height: 2em"
            class="ql-editor"
            v-html="newsDetail.content"
          ></div>
        </div>
      </div>
    </div>
    <div class="mobile" style="">
      <div style="text-align: left; padding: 0.6rem 0.26rem 0.2rem">
        <div style="color: #719468; font-size: 22px; line-height: 1.5">
          {{ newsDetail.title }}
        </div>
        <div
          style="
            font-size: 14px;
            color: #0000004d;
            margin-top: 0.2rem;
            padding-bottom: 0.15rem;
            border-bottom: 1px solid #e5e5e5;
          "
        >
          <i class="el-icon-user" style="margin-right: 1px"></i>
          <span style="margin-right: 12px">{{ newsDetail.authorName }}</span>
          <i class="el-icon-date" style="margin-right: 1px"></i>
          <span style="margin-right: 12px">{{ newsDetail.releaseTime }}</span>

          <i class="el-icon-view" style="margin-right: 1px"></i>
          <span>{{ newsDetail.readingOnFictitiou }}</span>
        </div>
      </div>
      <div
        style="
          margin-top: 0.1rem;
          line-height: 1.5;
          font-size: 17px;
          padding: 0 0.26rem;
        "
        class="ql-editor"
        v-html="newsDetail.content"
      ></div>
    </div>
    <!-- 底部 -->
    <RightBar></RightBar>
    <footerNav></footerNav>
  </div>
</template>

<script>
import headerNav from '@/components/headerNav/index'
import bannerNav from '@/components/banner/index'
import footerNav from '@/components/footerNav/index'
import { getNewsList, findNewsById } from '@/api/news'
import { getConfByKey, updateReadingVolume } from '@/api/common'

export default {
  name: 'newsDetail',
  components: { headerNav, footerNav, bannerNav },
  data() {
    return {
      info: {
        carousel: [],
        Mcarousel: '',
      }, //轮播图
      mobile: false,
      newsDetail: {}, //产品详情
    }
  },
  mounted() {
    this.goDetail()
  },
  methods: {
    setBanner(url, mUrl) {
      this.info = {
        carousel: [url],
        Mcarousel: [mUrl],
      }
    },
    goDetail() {
      findNewsById({ id: this.$route.params.id }).then((response) => {
        if(response.data!==null){
          this.newsDetail = response.data
          this.postMessage(
            this.newsDetail.title,
            this.newsDetail.description,
            window.location.href,
            this.getUrlPrefix(this.newsDetail.images)
          )
          this.navIndex = this.$route.params.type
          updateReadingVolume({ id: this.$route.params.id }).then()
        }else{
          this.$router.replace({name:'404'})
        }
      }).catch(()=>{
        this.$router.replace({name:'500'})
      })
      
    },
    goNew() {
      var path = `/newsCenter`
      this.$router.push({ path })
    },
    goback() {
      var path = `/newsCenter`
      this.$router.push({ path })
    },
    goHome() {
      this.$router.push({ name: 'home' })
    },
  },
}
</script>

<style lang="scss">
.productDetail {
  .maxWidth {
    width: 1067px;
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/newsCenter/detail.vue